import { ClientInferRequest, ClientInferResponseBody } from "@ts-rest/core";

import { api, contract } from "#app/http/api";
import { logger } from "#app/monitoring/Logger";
import { ApiError } from "#shared/infra/apiError";

export type UpdateQuoteRequestLineDto = ClientInferRequest<
  typeof contract.quoteRequestLines.update
>["body"];
export type QuoteRequestLineDto = ClientInferResponseBody<typeof contract.quoteRequestLines.update>;

const schema = contract.quoteRequestLines.update.responses[200];

export const updateQuoteRequestLine = async ({
  id,
  payload,
}: {
  id: string;
  payload: UpdateQuoteRequestLineDto;
}): Promise<QuoteRequestLineDto> => {
  const response = await api.quoteRequestLines.update.mutation({
    params: {
      id,
    },
    body: {
      ...payload,
    },
  });

  if (response.status !== 200) {
    throw new ApiError("Error updating quote request line", response.status, response.body);
  }

  const parsedResponse = schema.safeParse(response.body);

  if (!parsedResponse.success) {
    logger.error(`Error updating quote request line ${id}`);

    return response.body;
  }

  return parsedResponse.data;
};
